import { bunja } from 'bunja';
import { atom } from 'jotai';
import { atomWithMutation } from 'jotai-tanstack-query';

import { putAdjustMarginApi } from '@flipster/apis/v2/trade';
import { snackbar } from '@flipster/react/design-system/snackbar';
import { JotaiStoreScope } from '@flipster/utils/bunja-jotai';
import { getErrorMessage } from '@flipster/utils/error';

import { tradeRequestBaseBunja } from '../base-params';

interface AdjustMarginVariables {
  symbol: string;
  slot: number;
  /** 서버에 보내는 조정 금액. 부호(add/remove)는 호출측이 이미 반영해 넘긴다. */
  amount: string;
}

/**
 * 포지션 isolated 마진 조정 액션 (구 apps/web useAdjustMarginModal의 실행 로직).
 * 에러는 스낵바 표시 후 rethrow — 호출측(모달)이 열림 상태를 유지할 수 있게 한다.
 */
export const adjustMarginActionBunja = bunja(() => {
  const store = bunja.use(JotaiStoreScope);
  const { getBase } = bunja.use(tradeRequestBaseBunja);

  const putAdjustMarginApiAtom = atomWithMutation(() => ({
    mutationKey: ['putAdjustMarginApi'],
    mutationFn: ({ symbol, slot, amount }: AdjustMarginVariables) =>
      putAdjustMarginApi(symbol, slot, { ...getBase(), amount }),
  }));

  const isAdjustMarginLoadingAtom = atom((get) => get(putAdjustMarginApiAtom).isPending);

  const adjustMargin = async (variables: AdjustMarginVariables): Promise<void> => {
    try {
      await store.get(putAdjustMarginApiAtom).mutateAsync(variables);
    } catch (error) {
      snackbar.error({ message: getErrorMessage(error) });
      throw error;
    }
  };

  return { adjustMargin, isAdjustMarginLoadingAtom };
});
adjustMarginActionBunja.debugLabel = 'adjustMarginActionBunja';
